export const CONFIG = {
    API_BASE_URL:
        'https://host.geetek.ai',
    ADMIN_BASE_URL:
        'https://cms.geetek.ai',
    ADMIN_BASE_URL_LOGIN:
        'https://cms.geetek.ai/#/login',
    ADMIN_BASE_URL_REGISTER:
        'https://cms.geetek.ai/#/register'
};